import React from "react";
import styled from "styled-components";
import getConfig from "next/config";
import Link from "next/link";

const { publicRuntimeConfig } = getConfig();
const skin = process.env.NEXT_PUBLIC_REACT_APP_SKIN;
const StyledLogo = styled.div`
  a {
    text-decoration: none;
    color: white;
  }
  align-items: center;
  display: flex;
  color: white;
  img {
    margin-top: ${skin === "irsein" ? "-14px": "-24px"};
    cursor: pointer;
  }

  .logo-title  {
    display: inline-flex;
    flex-direction: column;
    margin-left: 12px;
    text-align: center;

    .logo-text  {
      font-size: 28px;
      line-height: 28px;
      font-weight: 600;
    }

    .logo-subtext  {
      font-size: 14px;
      line-height: 18px;
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    margin-bottom: 4px;

    img {
      margin-top: 0;
      max-width: 95%;
    }

    .logo-title  {
      .logo-text  {
        font-size: 22px;
        line-height: 22px;
      }

      .logo-subtext  {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
`;

const Logo = () => {

  return (
    <StyledLogo>
      <Link href="/">
        <a>
      <span className="logo-title">
        <span className="logo-text">
          Tax ID/EIN Application {`(${new Date().getFullYear()})`}
        </span>
        <span className="logo-subtext">
          Approved 3rd Party eFile Provider
        </span>
      </span>
        </a>
      </Link>
    </StyledLogo>
  );
};

export default Logo;
